module.exports = __webpack_public_path__ + "static/media/YF37_4.49b6a8eb.jpg";